import { ParticipationDataService } from '../_services/participation-data.service';

export class CookieLogic {
  constructor(public service: ParticipationDataService) {}
  /**
   * this method used for set cookies.
   * @param name
   * @param value
   * @param expiracy
   */
  setCookie(name, value, expiracy) {
    let d = new Date();
    d.setTime(d.getTime() + expiracy * 24 * 60 * 60 * 1000);
    let c_value = encodeURIComponent(value) + (expiracy == null ? '' : '; expires=' + d.toUTCString());
    document.cookie = name + '=' + c_value + '; path=/';
  }

  /**
   * this method used for get cookies.
   * @param c_name
   * @returns
   */
  public getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + '=');
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(';', c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return decodeURIComponent(document.cookie.substring(c_start, c_end));
      }
    }
    return '';
  }

  /***
   * this method use for set cookies
   */
  setAcceptCookie(cname: string, cvalue: string, exdays: number) {
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';

    if (this.service.commonSetting.SurveyURL.indexOf('https://') > -1) {
      document.cookie = 'Enabled=true;SameSite=None; Secure;';
    } else {
      document.cookie = 'Enabled=true;';
    }
  }

  public deleteCookie(cookie_name) {
    let cookie_date = new Date();
    cookie_date.setTime(cookie_date.getTime() - 1);
    document.cookie = cookie_name += '=; expires=' + cookie_date.toUTCString() + '; path=/';
  }

  /**
   * this method use for get cookies
   * @param cname
   * @returns
   */
   getAcceptCookie(cname: string) {
    let name = cname + '=11';
    let name_2 = cname + '=10';
    let ca = document.cookie.split(';');
    for (var c of ca) {
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0 || c.indexOf(name_2) == 0) {
        return c.toString();
      }
    }
    return '';
  }

  /**
   * this method used for set download cookies.
   * @param name
   * @param value
   * @param expiracy
   */

  public setDownloadCookie(name, value, expiracy) {
    let exdate = new Date();
    exdate.setTime(exdate.getTime() + expiracy * 1000);
    let c_value = encodeURIComponent(value) + (expiracy == null ? '' : '; expires=' + exdate.toUTCString());
    document.cookie = name + '=' + c_value + '; path=/';
  }

  /**
   * this method used for get download cookies.
   * @param name
   * @returns
   */

  public getDownloadCookie(name) {
    const ARRcookies = document.cookie.split(';');
    for (const cookie of ARRcookies) {
      let [x, y] = cookie.split('=');
      x = x.trim();
      if (x === name) {
        return y ? decodeURIComponent(y.replace(/\+/g, ' ')) : y;
      }
    }
  }
}
